/* eslint-disable */
import { base, baseFile} from '@/utils/api'
  
const ENDPOINT = '/warehouse'

export default {
    // StockRequest
    getStockRequests(data) {
        const config = {
            params: data
        }
        return base.get(`${ENDPOINT}/request`, config);
    },
    createStockRequest(data) {
        return base.post(`${ENDPOINT}/request`, data);
    },
    updateStockRequest(stockRequestId, data) {
        return base.put(`${ENDPOINT}/request/${stockRequestId}`, data);
    },
    findStockRequest(stockRequestId) {
        return base.get(`${ENDPOINT}/request/${stockRequestId}`);
    },
    disapproveRequest(stockRequestId) {
        return base.get(`${ENDPOINT}/request/${stockRequestId}/disapprove`);
    },
    // ProductRequest
    getProductStockRequests(data) {
        const config = {
            params: data
        }
        return base.get(`${ENDPOINT}/product-request`, config);
    },
    deleteProductStockRequests(id) {
        return base.delete(`${ENDPOINT}/product-request/${id}`);
    },
    disapproveProductRequest(productRequestId) {
        return base.get(`${ENDPOINT}/product-request/${productRequestId}/disapprove`);
    },
    // Observaçoes do Produto
    createProductStockComment(data) {
        return base.post(`${ENDPOINT}/product-request/comment`, data);
    },
    // Batches
    getAvailableBatches(clinicId, productId) {
        return base.get(`${ENDPOINT}/clinic/${clinicId}/batches/${productId}/available`);
    },

    getProductBatches (productId, filters = {}) {
        const config = {
            params: { filters }
        }
        return base.get(`warehouse/getProductBatches/${productId}`, config);
    },
    decreaseBatchOutput(warehouseOutputId) {
        return base.get(`${ENDPOINT}/outputs/${warehouseOutputId}/batch/decrease`);
    },
    decreaseBatchFromLocal(clinicId, batchId, localStockSectorId) {
        return base.get(`${ENDPOINT}/clinic/${clinicId}/batches/${batchId}/${localStockSectorId}/decrease`);
    },
    getKitByCode(code) {
        return base.get(`${ENDPOINT}/kits/getByCode/${code}`);
    },
}